import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { SELECTED_BORDER } from 'src/config/styles'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 62,
    overflow: 'hidden',
    cursor: 'pointer',

    '&:last-child': {
      marginBottom: 24,
      borderRadius: '0px 0px 8px 8px',
    },
  },
  treatmentInfoContainer: {
    padding: 16,
    width: '100%',
    '&:hover': {
      background: theme.palette.grey[100],
    },
  },
  treatmentNameContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  duration: {
    color: theme.palette.grey[700],
    ...typography['Lato Emphasized 2'],
    [forPhoneOnly]: {
      ...typography['Lato Caption Bold'],
    },
  },
  selected: {
    border: SELECTED_BORDER(theme),
    borderRadius: 8,
  },
  treatmentName: {
    ...typography['Lato Emphasized 1'],
  },
  treatmentSeparator: {
    height: 1,
    width: '100%',
    background: theme.palette.grey[200],
  },
}))
